import { IDateFormat } from "amnShared/interfaces/IDates";
import { ITimeFormat } from "amnShared/interfaces/ITimes";

export enum NegativeDisplay {
  NegativeSignDefaultColor,
  NegativeSignRedColor,
  ParenthesesDefaultColor,
  ParenthesesRedColor,
}
export enum ThousandsSeperatorType {
  Comma,
  Dot,
}
export const NegativeDisplayOptions = [
  {
    option: NegativeDisplay.NegativeSignDefaultColor,
  },
  {
    option: NegativeDisplay.NegativeSignRedColor,
  },
  {
    option: NegativeDisplay.ParenthesesDefaultColor,
  },
  {
    option: NegativeDisplay.ParenthesesRedColor,
  },
];

export const SeperatorType = [
  { option: ThousandsSeperatorType.Comma },
  { option: ThousandsSeperatorType.Dot },
];

export const DateFormatOptions = [
  {
    option: IDateFormat.DD_MM_YYYY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.D_M_YYYY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.DD_MM_YY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.D_M_YY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.MM_DD_YYYY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.M_D_YYYY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.MM_DD_YY_HH_MM_AMPM,
  },
  {
    option: IDateFormat.M_D_YY_HH_MM_AMPM,
  },
];

export const TimeFormatOptions = [
  {
    option: ITimeFormat.TIME_24HR
  },
  {
    option: ITimeFormat.TIME_12HR
  }
]